import axios from '@/libs/api.request';

export const getCombineCommission = data => {
    return axios.request({
        url: 'api/financeManagement/commission/getCombineCommission',
        data: data,
        method: 'post'
    });
};
export const getCombineCommissionSql = data => {
    return axios.request({
        url: 'api/financeManagement/commission/getCombineCommissionSql',
        data: data,
        method: 'post'
    });
};

export const getCombineCommissionDetail = data => {
    return axios.request({
        url: 'api/financeManagement/commission/getCombineCommissionDetail',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmModel = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmModel',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmCommissionRate = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmCommissionRate',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmCommissionRecordList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmCommissionRecordList',
        data: data,
        method: 'post'
    });
};
//抛头/赠送率
export const saveSeedFarmAdditionalRate = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmAdditionalRate',
        data: data,
        method: 'post'
    });
};
//抛头/赠送率修改记录
export const getSeedFarmAdditionalRecordList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmAdditionalRecordList',
        data: data,
        method: 'post'
    });
};